import AccessoryCommon from "./accessoryCommon";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import {ShowerAccessories} from "../../parts/showerAccessories";
import {shouldUseSafetyPackage, updateFeatureGroupsWithNewSide} from "../../safetyPackageSidesLogic";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {ShowerComboTubType} from "../../constants";

export default class HandShowerKit extends AccessoryCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'hand_shower_kit';
    this.partName = 'Hand Shower Kit';
    this.translateId = "visualizer.bathroom.shower.hand_shower_kit";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      this.oneLayerPosition = true;
    }
  }

  load(dbFeature) {
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    return super.loadAsBV6(dbFeature);
  }

  disabledClick() {
    super.disabledClick();
    if (!this.disabled && this.activeFeature) {
      const layout = this.getParent().layout;
      if (layout.parts[ShowerAccessories.id]?.handleShowerValve) {
        layout.parts[ShowerAccessories.id].handleShowerValve.checkValveMountType(this);
      }
      if (shouldUseSafetyPackage(this) && this.activeFeature.metaData["layerPosition"]) {
        updateFeatureGroupsWithNewSide(this.activeFeature, this.activeFeature.metaData["layerPosition"]);
      }
    }
  }

  handleClick(ignoreLocked) {
    super.handleClick(ignoreLocked);
    if (this.notAvailableInVisualizer || getFeatureIsLocked(this)) {
      return
    }
    const layout = this.getParent().getParent().layout;
    if (layout.parts[ShowerAccessories.id]?.handleShowerValve) {
      layout.parts[ShowerAccessories.id].handleShowerValve.checkValveMountType(this);
    }
  }

  hideLayerCondition() {
    const comboPart = this.getParent().layout.parts[ShowerTubCombo.id];
    return !!(comboPart && comboPart.showerTubComboIsActive && comboPart.bottomTub === ShowerComboTubType.walk_in_tub);
  }

  navigationSubItems(filters, searchText) {
    return this.navigationSubItemsWithSides(filters, searchText);
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Accessories.HandShowerKit;
    }
  }

}
